import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'

import { AuthPage, NewEventPage, PrivateRoute, PublicRoute } from 'components'
import useAuthState from 'hooks/useAuthState'
import { ROUTES } from 'helpers/constants'

import Dashboard from './Dashboard'
import DiscoverPage from 'components/Discover'
import EventPage from 'components/EventPage'
import PartnerPortal from './Host/PartnerPortal'
import PartnerPortalEventPage from './Host/PartnerPortal/PartnerPortalEventPage'
import Login from './Auth/Login'
import Profile from './Profile'
import Settings from './Settings'
import PublicProfile from 'components/PublicProfile'
import AdminDiscover from 'components/Discover/AdminDiscover'
import SocialAccountCallback from 'pages/SocialAccountCallback'
import AdminPortal from 'pages/admin'
import Membership from 'pages/Membership'

const {
  TICKETS,
  ADMIN_PROFILES,
  ADMIN_PORTAL,
  APP_CLIP,
  EVENT_CREATE,
  EVENT_LOGIN,
  EVENT,
  HOST_INVITE_LOGIN,
  HOST_PORTAL,
  HOST_PORTAL_EVENT_PAGE,
  BACHELORETTE_PROFILE,
  LANDING,
  LANDING_INVITE,
  LOGIN,
  PROFILE,
  PUBLIC_PROFILE,
  MEMBERSHIP,
  SETTINGS,
  SIGNUP,
  SOCIAL_ACCOUNT_CALLBACK,
} = ROUTES

const Routes = () => {
  const { user } = useAuthState()

  return (
    <Switch>
      <Route component={Login} path={LOGIN} strict />
      <Route component={Login} path={EVENT_LOGIN} strict />
      <Route component={Login} path={HOST_INVITE_LOGIN} strict />
      {/*<Route component={ResetPassword} path={RESET_PASSWORD} />*/}
      {/*<PublicRoute path={HOST_PROFILE}>
        <HostProfile />
      </PublicRoute>*/}
      {/* <PrivateRoute path={VIDEOCHAT} showHeader={false} showFooter={false}>
        <VideoChat />
      </PrivateRoute>*/}
      <PrivateRoute path={TICKETS} showFooter={false}>
        <Dashboard user={user} />
      </PrivateRoute>
      {/* Uncomment once we are ready to add the page again. */}
      {/* <PrivateRoute path={EVENT_EDIT}>
        <EditEventPage />
      </PrivateRoute> */}
      <PrivateRoute path={PROFILE}>
        <Profile />
      </PrivateRoute>
      <PrivateRoute path={SETTINGS}>
        <Settings />
      </PrivateRoute>
      <PrivateRoute path={MEMBERSHIP}>
        <Membership />
      </PrivateRoute>
      <PrivateRoute path={EVENT_CREATE}>
        <NewEventPage />
      </PrivateRoute>
      {/* <PrivateRoute path={TOKEN}>
        <TokenPage />
      </PrivateRoute>*/}
      <PrivateRoute path={HOST_PORTAL_EVENT_PAGE} showFooter={false}>
        <PartnerPortalEventPage user={user} />
      </PrivateRoute>
      <PrivateRoute path={HOST_PORTAL} showFooter={false}>
        <PartnerPortal user={user} />
      </PrivateRoute>
      {/*<PrivateRoute path={`${MATCHES}/:userId?`} showFooter={false}>
        <Chat />
      </PrivateRoute>*/}
      {/* <PrivateRoute path={WALLETS} showFooter={false}>
        <Wallets />
      </PrivateRoute>*/}
      {/*<PrivateRoute path={LIKES} showFooter={false}>
        <Likes />
      </PrivateRoute>*/}
      {/*<PrivateRoute path={META_TOUCH} showFooter={false}>
        <MetaTouch />
      </PrivateRoute>*/}
      <PrivateRoute path={SOCIAL_ACCOUNT_CALLBACK} showFooter={false}>
        <SocialAccountCallback />
      </PrivateRoute>
      <PublicRoute exact path={EVENT}>
        <EventPage />
      </PublicRoute>
      {/*<PublicRoute exact path={EVENT_LIVE} showHeader={false} showFooter={false}>
        <EventLivePage />
      </PublicRoute>*/}
      {/*<PublicRoute path={HOST_SIGNUP}>
        <HostSignup />
      </PublicRoute>*/}
      <Redirect from={BACHELORETTE_PROFILE} to={PUBLIC_PROFILE} />
      <PublicRoute path={PUBLIC_PROFILE} showFooter={false}>
        <PublicProfile />
      </PublicRoute>
      <PublicRoute path={SIGNUP} showHeader={false} showFooter={false}>
        <AuthPage />
      </PublicRoute>
      <PublicRoute path={LANDING_INVITE} showFooter={false} showHeader={!!user}>
        <DiscoverPage />
      </PublicRoute>
      <PrivateRoute path={ADMIN_PROFILES} showFooter={false} showHeader={!!user}>
        <AdminDiscover />
      </PrivateRoute>
      <PrivateRoute path={ADMIN_PORTAL} showFooter={false} showHeader={!!user}>
        <AdminPortal />
      </PrivateRoute>
      {/*<PrivateRoute path={ADMIN_DREAM_BOOTH_IMAGE} showFooter={false} showHeader={!!user}>
        <DreamBoothImage />
      </PrivateRoute>
      <PrivateRoute path={ADMIN_DREAM_BOOTH_MODEL} showFooter={false} showHeader={!!user}>
        <DreamBoothModel />
      </PrivateRoute>*/}
      <PublicRoute path={APP_CLIP} showFooter={false} showHeader={false}>
        <div>
          <h2>
            <span className="text-white">App Clip 2</span>
          </h2>
        </div>
      </PublicRoute>
      <PublicRoute path={LANDING} showFooter={false} showHeader={!!user}>
        <DiscoverPage />
      </PublicRoute>
    </Switch>
  )
}

export default Routes
